import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home.vue'
import AssetList from './components/AssetList.vue'
import ProgramList from './components/ProgramList.vue'
import ServerData from './components/ServerData'
import TopDomains from './components/TopDomains'
import DnsRecordList from "@/components/DnsRecordList";

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/assets',
      name: 'Assets',
      component: AssetList
    },
    {
      path: '/programs',
      name: 'Programs',
      component: ProgramList
    },
    {
      path: '/subdomains',
      name: 'Subdomains',
      component: DnsRecordList,
    },
    {
      path: '/top-domains',
      name: 'TopDomains',
      component: TopDomains,
    },
    {
      path: '/servers',
      name: 'ServerData',
      component: ServerData,
    },
  ]
})

const DEFAULT_TITLE = 'iSee';
router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router